"use client";

import { useState, useEffect } from "react";
import Link from "next/link";
import dynamic from "next/dynamic";
import { useRouter, useParams, useSearchParams } from "next/navigation";
import { fallbackLng, languages } from '../app/i18n/settings'
import acceptLanguage from 'accept-language'

acceptLanguage.languages(languages)

const TelegramLoginButton = dynamic(() => import("./TelegramLoginButton"), {
  ssr: false,
  loading: () => (
    <div className="w-[238px] h-[40px] bg-blue-500 rounded-full"></div>
  ),
});

export default function LoginButtons() {
  const router = useRouter();
  const params = useParams();
  const searchParams = useSearchParams();
  const [lng, setLng] = useState(fallbackLng);

  useEffect(() => {
    const detectLanguage = () => {
      // Check query string first
      const queryLng = searchParams.get('lng');
      if (queryLng) {
        return queryLng;
      }
      // Then check params
      if (params.lng) {
        return params.lng;
      }
      // Finally, fall back to browser language
      const acceptLang = window.navigator.language;
      return acceptLanguage.get(acceptLang) || fallbackLng;
    };
    setLng(detectLanguage());
  }, [params.lng, searchParams]);

  const handleLineLogin = () => {
    // Passing things to the app if needed
  };

  const handleTelegramLogin = (telegramAuthData) => {
    localStorage.setItem("telegramAuthData", JSON.stringify(telegramAuthData));
    router.push(`/${lng}/app?authProvider=telegram`);
  };

  return (
    <div className="flex flex-col sm:flex-row gap-4 items-center justify-center">
      <Link
        href={`${process.env.NEXT_PUBLIC_LIFF_URL}?redirect_uri=${encodeURIComponent(`${typeof window !== 'undefined' ? window.location.origin : ''}/app?authProvider=line&lng=${lng}`)}`}
        className="bg-green-500 text-white px-6 rounded-full text-lg font-semibold hover:bg-green-600 transition-colors inline-flex items-center justify-center h-[40px]"
        onClick={handleLineLogin}
      >
        <svg
          className="w-5 h-5 mr-2"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
            clipRule="evenodd"
          />
        </svg>
        Login with LINE
      </Link>
      <TelegramLoginButton onAuth={handleTelegramLogin} />
    </div>
  );
}
